import { sortObjectListByKey } from 'utils/arrayHelpers';
import { CombinedRole } from '../types';

/**
 * Creates a dropdown list of roles by sorting them alphabetically and adding
 * a "None" option since this field is optional
 */
export const createRolesOptions = (roles: CombinedRole[]) => {
  const sortedRoles = sortObjectListByKey(roles, 'name');
  return sortedRoles.map(({ id, name }) => ({
    id: id.toString(),
    label: name,
    value: id,
  }));
};

/**
 * utility function extraced out of sortRolesByKey to make more readable
 * @param roles
 * @param isDescending
 * @returns Role[]
 */
const sortRolesByKeyLength = (
  roles: CombinedRole[],
  key: 'members' | 'permissions',
  isDescending = false,
) => {
  const sortedByKey = [...roles].sort((a, b) => (a[`${key}`].length < b[`${key}`].length ? -1 : 1));
  return isDescending ? sortedByKey.reverse() : sortedByKey;
};

/**
 *
 * @param roles Role
 * @param sortBy keyof Role
 * @param isDescending boolean
 * @returns Role[] Sorted roles by the selected key (ie. name, permissions length, last modified)
 */
export const sortRolesByKey = (roles: CombinedRole[], sortBy: string, isDescending = false) => {
  return sortBy === 'members' || sortBy === 'permissions'
    ? sortRolesByKeyLength(roles, sortBy, isDescending)
    : sortObjectListByKey(roles, sortBy as keyof CombinedRole, isDescending);
};
